import axios from 'axios';
import { getCookie } from '../_helpers/cookie';

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const buildHeaders = (token) => ({
  Authorization: `Bearer ${token || ''}`,
  'x-api-key': X_API_KEY,
});

export const invoiceConfigurationService = {
  fetchConfig,
  updateConfig,
};

function fetchConfig(token) {
  const authToken = token || getCookie('token');
  return axios
    .get(`${API_URL}tenant-invoice-config/`, {
      headers: buildHeaders(authToken),
    })
    .then((response) => response.data);
}

function updateConfig(payload, token) {
  const authToken = token || getCookie('token');
  return axios
    .post(`${API_URL}tenant-invoice-config/`, payload, {
      headers: {
        ...buildHeaders(authToken),
        'Content-Type': 'application/json',
      },
    })
    .then((response) => response.data);
}

